export const XLSX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const isSaveFilePickerSupported = () =>
  typeof (window as any).showSaveFilePicker === "function";

/**
 * Opens the OS Save As dialog. Must be called synchronously within a user
 * gesture (button click) — calling it after a slow API request makes the
 * browser reject it for lack of user activation.
 *
 * Returns the chosen file handle, "cancelled" if the user dismissed the
 * dialog, or null if the picker is unavailable/failed (caller should fall
 * back to a direct download).
 */
export const openSaveFileDialog = async (
  suggestedName: string,
  mimeType?: string,
  extension?: string
): Promise<any | "cancelled" | null> => {
  if (!isSaveFilePickerSupported()) return null;
  try {
    const options: any = { suggestedName };
    if (mimeType && extension) {
      options.types = [
        {
          description: extension.replace(".", "").toUpperCase() + " File",
          accept: { [mimeType]: [extension] },
        },
      ];
    }
    return await (window as any).showSaveFilePicker(options);
  } catch (error: any) {
    if (error?.name === "AbortError") return "cancelled";
    return null;
  }
};

export const writeBlobToHandle = async (handle: any, blob: Blob) => {
  const writable = await handle.createWritable();
  await writable.write(blob);
  await writable.close();
};

export const base64ToBlob = (base64Content: string, mimeType: string) => {
  const byteChars = atob(base64Content);
  const bytes = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    bytes[i] = byteChars.charCodeAt(i);
  }
  return new Blob([bytes], { type: mimeType });
};

export const downloadBlobDirectly = (blob: Blob, fileName: string) => {
  const objectUrl = URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");
  downloadLink.href = objectUrl;
  downloadLink.download = fileName;
  downloadLink.click();
  URL.revokeObjectURL(objectUrl);
};
